import { type FormField } from '@elfsight/widget-form-builder/widget';
import { useLingui } from '@lingui/react/macro';
import {
  EMAIL_ID,
  LOGO_ID,
  PRIZE_BUTTON_LINK_ID,
  PRIZE_BUTTON_TEXT_ID,
  PRIZE_COUPON_ID,
  PRIZE_HEADING_ID,
  PRIZE_TEXT_ID,
  WEBPAGE_ID
} from './constants';

export function useGetFields() {
  const { t } = useLingui();

  const emailField: FormField = {
    id: EMAIL_ID,
    placeholder: t`Enter your email...`,
    showLabel: false,
    label: t`Email`,
    name: 'email',
    type: 'email'
  };

  const hiddenFields: FormField[] = [
    {
      id: PRIZE_HEADING_ID,
      type: 'hidden'
    },
    {
      id: PRIZE_TEXT_ID,
      type: 'hidden'
    },
    {
      id: PRIZE_COUPON_ID,
      type: 'hidden'
    },
    {
      id: PRIZE_BUTTON_TEXT_ID,
      type: 'hidden'
    },
    {
      id: PRIZE_BUTTON_LINK_ID,
      type: 'hidden'
    },
    {
      id: LOGO_ID,
      type: 'hidden'
    },
    {
      id: WEBPAGE_ID,
      type: 'hidden'
    }
  ];

  return [...hiddenFields, emailField];
}
